// Search history management using localStorage

const STORAGE_KEY = 'saintPatronSearchHistory';
const MAX_HISTORY = 10;

export const getSearchHistory = () => {
  try {
    const history = localStorage.getItem(STORAGE_KEY);
    return history ? JSON.parse(history) : [];
  } catch (error) {
    console.error('Error reading search history:', error);
    return [];
  }
};

export const addToSearchHistory = (name) => {
  if (!name || !name.trim()) return;
  
  try {
    const normalizedName = name.trim();
    // Capitalize first letter
    const formattedName = normalizedName.charAt(0).toUpperCase() + normalizedName.slice(1).toLowerCase();
    
    let history = getSearchHistory();
    
    // Remove if already exists (to move it to the front)
    history = history.filter(item => item.toLowerCase() !== formattedName.toLowerCase());
    
    // Add to the beginning
    history.unshift(formattedName);
    
    // Keep only the last MAX_HISTORY items
    history = history.slice(0, MAX_HISTORY);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    
    return history;
  } catch (error) {
    console.error('Error saving search history:', error);
    return getSearchHistory();
  }
};

export const clearSearchHistory = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing search history:', error);
  }
};

// Default suggestions when no history exists
export const getDefaultSuggestions = (language) => {
  if (language === 'fr') {
    return ['Marie', 'Pierre', 'Jean', 'François', 'Thérèse', 'Antoine', 'Claire', 'Joseph'];
  }
  return ['Mary', 'Peter', 'John', 'Francis', 'Theresa', 'Anthony', 'Clare', 'Joseph'];
};

export default {
  getSearchHistory,
  addToSearchHistory,
  clearSearchHistory,
  getDefaultSuggestions
};
